<template>
  <v-dialog v-model="dialog" width="800" scrollable>
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Pilih Sekolah</v-toolbar-title>
          <v-spacer />
          <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <base-table-header outlined-button btn-filter @search="onSearch" @filter="onFilter" @reload="onReload">
        <template v-slot:subtitle>
          <div class="subtitle-1 black--text"> {{ total }} Sekolah </div>
        </template>
        <template v-slot:toolbar>
          <div style="max-width: 200px">
            <v-row no-gutters>
              <v-col cols="12" class="py-2 pr-1">
                <v-select
                  v-model="jenjang"
                  light
                  flat
                  dense
                  outlined
                  hide-details
                  :items="mJenjang"
                  @change="onChangeJenjang"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </template>
      </base-table-header>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <v-container>
          <div>
            <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
              <template slot-scope="{ item }">
                <td>
                  <v-list>
                    <v-list-item dense class="px-0" :disabled="disabled.includes(+item.sekolah_id)">
                      <v-list-item-avatar color="secondary">
                        <v-icon dark>mdi-home</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" lg="7">
                            <div :class="['body-1', disabled.includes(+item.sekolah_id) ? 'grey--text' : 'info--text']">
                              {{ $getDeepObj(item, 'sekolah.nama') }}
                            </div>
                            <div class="body-2">
                              <div>
                                <span class="font-weight-medium">NPSN: </span>
                                {{ $getDeepObj(item, 'sekolah.npsn') }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                      <v-list-item-action-text v-if="!disabled.includes(+item.sekolah_id)">
                        <v-btn
                          icon
                          :color="selectedItem.includes(+item.sekolah_id) ? 'success' : 'grey'"
                          @click="onSelectItem(item)"
                        >
                          <v-icon>
                            {{
                              selectedItem.includes(+item.sekolah_id)
                                ? 'mdi-checkbox-marked'
                                : 'mdi-checkbox-blank-outline'
                            }}
                          </v-icon>
                        </v-btn>
                      </v-list-item-action-text>
                    </v-list-item>
                  </v-list>
                </td>
              </template>
            </base-list-table>
          </div>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
          </v-col>
          <v-col cols="12" class="text-right pt-0">
            <div>
              <span class="blue--text body-1">{{ selected.length || 0 }}</span> Sekolah Terpilih
            </div>
            <v-btn color="success" depressed @click="onSelect">Pilih Sekolah</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';
export default {
  mixins: [list],
  props: {
    customParams: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      selected: [],
      disabled: [],
      kategori: '',
      jenjang: '',
    };
  },

  computed: {
    selectedItem() {
      return this.selected.map((item) => item.sekolah_id);
    },

    mJenjang() {
      return [
        { text: 'Semua Jenjang', value: '' },
        { text: 'PAUD', value: 1 },
        { text: 'SD', value: 2 },
        { text: 'SMP', value: 3 },
        { text: 'SMA', value: 4 },
        { text: 'SMK', value: 5 },
        { text: 'SLB', value: 6 },
      ];
    },

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [
          { cols: 12, lg: 6 },
          { cols: 12, lg: 6 },
        ],
        disabled: [],
      };
    },

    formFilter() {
      return [
        {
          label: 'Pilih Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
        },
      ];
    },

    filtersMaster() {
      return {
        k_propinsi: this.masters && this.masters['propinsi'],
        k_kota: this.masters && this.masters['kota'],
      };
    },
  },

  methods: {
    ...mapActions('pengimbasanKelas', ['candidate']),

    fetchData() {
      return new Promise((resolve) => {
        const params = Object.assign(
          {},
          this.params,
          this.$isObject(this.filters) ? this.filters : {},
          this.customParams
        );
        this.candidate({ endpoint: 'sekolah', params: params, id: this.id }).then(
          ({ data, total, last_page, per_page }) => {
            this.data = data || [];
            this.total = total || 0;
            this.pageTotal = last_page || 1;
            this.params.limit = per_page || this.params.limit;
            resolve(true);
          }
        );
      });
    },

    open(disabled) {
      this.dialog = true;
      this.data = [];
      this.selected = [];
      this.disabled = disabled || [];
      this.params = { page: 1, limit: 10 };
      this.jenjang = '';
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect() {
      this.resolve(this.selected);
      this.dialog = false;
    },

    onSelectItem(item) {
      const findIndex = this.selected.findIndex((s) => s.sekolah_id === item.sekolah_id);
      if (findIndex > -1) {
        this.selected.splice(findIndex, 1);
      } else {
        this.selected.push(item);
      }
    },

    onChangeJenjang() {
      this.params.k_jenjang = this.jenjang;
      this.fetchData();
    },
  },
};
</script>
<style scoped>
>>> .v-dialog {
  overflow-y: hidden;
}
</style>
